module.exports = __webpack_public_path__ + "static/media/output-onlinepngtools.5b5ebb8a.png";